<template>
    <vx-selectable
        v-model="model"
        :options="options"
        :loading="loading"
        :placeholder="props.placeholder"
        :clearable="props.clearable"
        :relativeDropdown="props.relativeDropdown"
        :size="props.size"
        data-test="membership-status-selectable"
    />
</template>

<script lang="ts" setup>
import { VxSelectable } from '@voxie/frontend-components';
import { computed } from 'vue';
import { useMembershipStatusDefinitions } from '~/composables/useMembershipStatusDefinitions';

const props = withDefaults(
    defineProps<{
        placeholder?: string;
        clearable?: boolean;
        relativeDropdown?: boolean;
        size?: 'sm' | 'md' | 'lg' | 'xl';
    }>(),
    {
        placeholder: 'Search',
        clearable: false,
        relativeDropdown: false,
        size: 'md',
    }
);

const model = defineModel<string>({ required: true });

const { definitions, loading } = useMembershipStatusDefinitions();
const options = computed<string[]>(() => (definitions.value ?? []).map((definition) => definition.name));
</script>
